import { render, staticRenderFns } from "./PFormDatepickerActions.vue?vue&type=template&id=67523262&scoped=true&"
import script from "./PFormDatepickerActions.vue?vue&type=script&lang=ts&"
export * from "./PFormDatepickerActions.vue?vue&type=script&lang=ts&"
import style0 from "./PFormDatepickerActions.vue?vue&type=style&index=0&id=67523262&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67523262",
  null
  
)

export default component.exports